export default __webpack_public_path__ + "static/media/img3.684cab9e.png";